import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@pinpoint/design-kit';
import DefaultTheme from 'src/styles/DefaultTheme';

const StyledButton = styled(Button)`
  :active {
    background-color: ${({ disabled }) => (!disabled ? DefaultTheme.colors.teal : '')};
  }
`;

function LoginButton({ children, ...userProps }) {
  return (
    <StyledButton
      bg="teal"
      hoverBg="blueLight"
      textColor="black"
      p={{ y: '1em', x: '1.5em' }}
      w="100%"
      textSize="input"
      type="button"
      {...userProps}
    >
      {children}
    </StyledButton>
  );
}

LoginButton.defaultProps = {
  children: null,
};

LoginButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default LoginButton;
